
import { Union, Record } from "../fable_modules/fable-library-js.5.3.0/Types.js";
import { union_type, list_type, class_type, lambda_type, unit_type, option_type, bool_type, record_type, string_type } from "../fable_modules/fable-library-js.5.3.0/Reflection.js";
import { UploadFailure, UploadFailureModule_ofHttpStatus, UploadedPhoto, ImageDimensions, PhotoFile_validateForUpload, acceptAttribute, UploadFailureModule_message, isSmallerThan, UploadFailure_$reflection, UploadedPhoto_$reflection, ImageDimensions_$reflection } from "./Photo.js";
import { ClientTypes_PhotoUploadState, ClientTypes_PhotoUploadState_$reflection } from "./ClientTypes.js";
import { padding_py2, gap_gap$002D1, margin_mt1, fontWeight_fontMedium, backgroundColor_bgNeutral50, padding_p4, margin_mt2, gap_gap$002D2, justifyContent_justifyCenter, alignItems_itemsCenter, textAlign_center, flexDirection_flexCol, display_flex, border_border2, width_w5, height_h5, animation_animateSpin, cursor_cursorPointer, borderRadius_roundedLg, fontSize_textSm, padding_px4, tw } from "../fable_modules/Feliz.Tailwind.4.0.2/Strings.fs.js";
import { textColor_textWarning800, textColor_textNeutral500, textColor_textPrimary700, textColor_textNeutral900, PeerFocusVisible_ring, textColor_textNeutral600, borderColor_borderNeutral300, borderColor_borderDanger500, borderColor_borderTTransparent, borderColor_borderPrimary600, borderRadius_roundedFull, FocusVisible_ringDanger, textColor_textDanger700, hover, textColor_textDanger600, minHeight_minH11 } from "./TailwindExtensions.js";
import { TailwindHelpers_helperText, TailwindHelpers_labelText, TailwindHelpers_buttonSecondary } from "./Layout/Layout.js";
import { empty as empty_1, append as append_1, singleton as singleton_1, ofArray } from "../fable_modules/fable-library-js.5.3.0/List.js";
import { HtmlHelper_createElement } from "../fable_modules/Feliz.3.3.3/Html.fs.js";
import { concat, join } from "../fable_modules/fable-library-js.5.3.0/String.js";
import { iterate, empty, singleton, append, delay, toList } from "../fable_modules/fable-library-js.5.3.0/Seq.js";
import { useEffect, useRef, createElement } from "react";
import React from "react";
import { IconWeight, IconSize, IconName, icon } from "./Icons.js";
import { defaultOf as defaultOf_1, disposeSafe, equals } from "../fable_modules/fable-library-js.5.3.0/Util.js";
import { defaultOf } from "../fable_modules/fable-library-js.5.3.0/Util.js";
import { toArray, defaultArg } from "../fable_modules/fable-library-js.5.3.0/Option.js";
import { fromFloat64, toInt64_unchecked } from "../fable_modules/fable-library-js.5.3.0/BigInt.js";
import { Operators_IsNull } from "../fable_modules/fable-library-js.5.3.0/FSharp.Core.js";

/**
 * Heading and explanation shown inside the empty chooser, above "Choose a photo"
 */
export class EmptyPrompt extends Record {
    constructor(Heading, Body) {
        super();
        this.Heading = Heading;
        this.Body = Body;
    }
}

export function EmptyPrompt_$reflection() {
    return record_type("Shared.ImageUpload.EmptyPrompt", [], EmptyPrompt, () => [["Heading", string_type], ["Body", string_type]]);
}

export class ImageUploadProps extends Record {
    constructor(InputId, Label, LabelVisuallyHidden, Hint, EmptyPrompt, PreviewAlt, PreviewClass, SmallImageThreshold, State, Disabled, AuthToken, OnUploadStarted, OnUploaded, OnFailed, OnRemove) {
        super();
        this.InputId = InputId;
        this.Label = Label;
        this.LabelVisuallyHidden = LabelVisuallyHidden;
        this.Hint = Hint;
        this.EmptyPrompt = EmptyPrompt;
        this.PreviewAlt = PreviewAlt;
        this.PreviewClass = PreviewClass;
        this.SmallImageThreshold = SmallImageThreshold;
        this.State = State;
        this.Disabled = Disabled;
        this.AuthToken = AuthToken;
        this.OnUploadStarted = OnUploadStarted;
        this.OnUploaded = OnUploaded;
        this.OnFailed = OnFailed;
        this.OnRemove = OnRemove;
    }
}

export function ImageUploadProps_$reflection() {
    return record_type("Shared.ImageUpload.ImageUploadProps", [], ImageUploadProps, () => [["InputId", string_type], ["Label", string_type], ["LabelVisuallyHidden", bool_type], ["Hint", option_type(string_type)], ["EmptyPrompt", option_type(EmptyPrompt_$reflection())], ["PreviewAlt", string_type], ["PreviewClass", string_type], ["SmallImageThreshold", option_type(ImageDimensions_$reflection())], ["State", ClientTypes_PhotoUploadState_$reflection()], ["Disabled", bool_type], ["AuthToken", option_type(string_type)], ["OnUploadStarted", lambda_type(unit_type, unit_type)], ["OnUploaded", lambda_type(UploadedPhoto_$reflection(), unit_type)], ["OnFailed", lambda_type(UploadFailure_$reflection(), unit_type)], ["OnRemove", lambda_type(unit_type, unit_type)]]);
}

class Wiring extends Record {
    constructor(InputProps, ReplaceProps, RemoveProps, TryAgainProps) {
        super();
        this.InputProps = InputProps;
        this.ReplaceProps = ReplaceProps;
        this.RemoveProps = RemoveProps;
        this.TryAgainProps = TryAgainProps;
    }
}

function Wiring_$reflection() {
    return record_type("Shared.ImageUpload.Wiring", [], Wiring, () => [["InputProps", list_type(class_type("Feliz.IReactProperty"))], ["ReplaceProps", list_type(class_type("Feliz.IReactProperty"))], ["RemoveProps", list_type(class_type("Feliz.IReactProperty"))], ["TryAgainProps", list_type(class_type("Feliz.IReactProperty"))]]);
}

function smallImageWarning(threshold) {
    return `This photo is small and may look blurry. Photos at least ${threshold.Width}×${threshold.Height} work best.`;
}

function isSmall(props, photo) {
    const matchValue = props.SmallImageThreshold;
    const matchValue_1 = photo.Dimensions;
    let matchResult, actual, threshold;
    if (matchValue != null) {
        if (matchValue_1 != null) {
            matchResult = 0;
            actual = matchValue_1;
            threshold = matchValue;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return isSmallerThan(threshold, actual);
        default:
            return false;
    }
}

const actionButtonClass = tw(ofArray([minHeight_minH11, TailwindHelpers_buttonSecondary]));

const removeButtonClass = tw(ofArray([minHeight_minH11, padding_px4, fontSize_textSm, textColor_textDanger600, hover(textColor_textDanger700), borderRadius_roundedLg, FocusVisible_ringDanger, cursor_cursorPointer]));

const spinner = HtmlHelper_createElement("div", ofArray([["aria-hidden", "true"], ["className", tw(ofArray([animation_animateSpin, borderRadius_roundedFull, height_h5, width_w5, border_border2, borderColor_borderPrimary600, borderColor_borderTTransparent]))]]));

function statusRegion(content) {
    return HtmlHelper_createElement("div", ofArray([["role", join(" ", ["status"])], ["children", [content]]]));
}

function dropzone(props, hasError) {
    return HtmlHelper_createElement("label", ofArray([["htmlFor", props.InputId], ["className", tw(toList(delay(() => append(singleton(display_flex), delay(() => append((props.EmptyPrompt != null) ? append(singleton(flexDirection_flexCol), delay(() => singleton(textAlign_center))) : empty(), delay(() => append(singleton(alignItems_itemsCenter), delay(() => append(singleton(justifyContent_justifyCenter), delay(() => append(singleton(gap_gap$002D2), delay(() => append(singleton(minHeight_minH11), delay(() => append(singleton(margin_mt2), delay(() => append(singleton(padding_p4), delay(() => append(singleton("border-2 border-dashed"), delay(() => append(singleton(hasError ? borderColor_borderDanger500 : borderColor_borderNeutral300), delay(() => append(singleton(borderRadius_roundedLg), delay(() => append(singleton(textColor_textNeutral600), delay(() => append(singleton(cursor_cursorPointer), delay(() => append(singleton(hover(backgroundColor_bgNeutral50)), delay(() => singleton(PeerFocusVisible_ring))))))))))))))))))))))))))))))))], ["children", toList(delay(() => append(singleton(createElement(icon, {
        name: new IconName(19, []),
        size: new IconSize(1, []),
        weight: new IconWeight(0, []),
    })), delay(() => {
        const matchValue = props.EmptyPrompt;
        if (matchValue == null) {
            return singleton(HtmlHelper_createElement("span", singleton_1(["children", singleton_1("Choose a photo")])));
        }
        else {
            const prompt = matchValue;
            return append(singleton(HtmlHelper_createElement("span", ofArray([["className", tw(ofArray([fontWeight_fontMedium, textColor_textNeutral900]))], ["children", singleton_1(prompt.Heading)]]))), delay(() => append(singleton(HtmlHelper_createElement("span", ofArray([["className", tw(singleton_1(fontSize_textSm))], ["children", singleton_1(prompt.Body)]]))), delay(() => singleton(HtmlHelper_createElement("span", ofArray([["className", tw(ofArray([fontWeight_fontMedium, textColor_textPrimary700]))], ["children", singleton_1("Choose a photo")]])))))));
        }
    }))))]]));
}

function errorAlert(errorId, failure) {
    return HtmlHelper_createElement("div", ofArray([["id", errorId], ["role", join(" ", ["alert"])], ["className", tw(ofArray([margin_mt1, display_flex, alignItems_itemsCenter, gap_gap$002D1, fontSize_textSm, textColor_textDanger600]))], ["children", [createElement(icon, {
        name: new IconName(7, []),
        size: new IconSize(0, []),
        weight: new IconWeight(1, []),
    }), HtmlHelper_createElement("span", singleton_1(["children", singleton_1(UploadFailureModule_message(failure))]))]]]));
}

function render(props, wiring) {
    let threshold;
    const hintId = concat(props.InputId, "-hint");
    const errorId = concat(props.InputId, "-error");
    let errorFailure;
    const matchValue = props.State;
    errorFailure = ((matchValue.tag === 4) ? matchValue.fields[0] : undefined);
    const describedBy = join(" ", toList(delay(() => append((props.Hint != null) ? singleton(hintId) : empty(), delay(() => ((errorFailure != null) ? singleton(errorId) : empty()))))));
    const isUploading = equals(props.State, new ClientTypes_PhotoUploadState(1, []));
    const preview = (thumbnailUrl) => HtmlHelper_createElement("img", ofArray([["className", props.PreviewClass], ["src", thumbnailUrl], ["alt", props.PreviewAlt]]));
    let statusContent;
    const matchValue_1 = props.State;
    switch (matchValue_1.tag) {
        case 1: {
            statusContent = HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([display_flex, alignItems_itemsCenter, gap_gap$002D2, padding_py2]))], ["children", [spinner, HtmlHelper_createElement("span", ofArray([["className", tw(ofArray([fontSize_textSm, textColor_textNeutral500]))], ["children", singleton_1("Uploading photo…")]]))]]]));
            break;
        }
        case 2: {
            const matchValue_2 = props.SmallImageThreshold;
            let matchResult, threshold_1;
            if (matchValue_2 != null) {
                if ((threshold = matchValue_2, isSmall(props, matchValue_1.fields[0]))) {
                    matchResult = 0;
                    threshold_1 = matchValue_2;
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0: {
                    statusContent = HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([margin_mt2, display_flex, alignItems_itemsCenter, gap_gap$002D2, fontSize_textSm, textColor_textWarning800]))], ["children", [createElement(icon, {
                        name: new IconName(34, []),
                        size: new IconSize(0, []),
                        weight: new IconWeight(1, []),
                    }), HtmlHelper_createElement("span", singleton_1(["children", singleton_1(smallImageWarning(threshold_1))]))]]]));
                    break;
                }
                default:
                    statusContent = HtmlHelper_createElement("span", ofArray([["className", "sr-only"], ["children", singleton_1("Photo uploaded")]]));
            }
            break;
        }
        default:
            statusContent = defaultOf();
    }
    let body;
    const matchValue_3 = props.State;
    body = ((matchValue_3.tag === 4) ? dropzone(props, true) : ((matchValue_3.tag === 2) ? preview(matchValue_3.fields[0].ThumbnailUrl) : ((matchValue_3.tag === 3) ? preview(matchValue_3.fields[0]) : ((matchValue_3.tag === 1) ? defaultOf() : dropzone(props, false)))));
    let hasPhoto;
    const matchValue_4 = props.State;
    switch (matchValue_4.tag) {
        case 2:
        case 3: {
            hasPhoto = true;
            break;
        }
        default:
            hasPhoto = false;
    }
    const actions = hasPhoto ? HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([margin_mt2, display_flex, "flex-wrap", gap_gap$002D2, alignItems_itemsCenter]))], ["children", [HtmlHelper_createElement("button", append_1(ofArray([["type", "button"], ["className", actionButtonClass], ["children", singleton_1("Replace photo")], ["disabled", props.Disabled]]), wiring.ReplaceProps)), HtmlHelper_createElement("button", append_1(ofArray([["type", "button"], ["className", removeButtonClass], ["children", singleton_1("Remove photo")], ["disabled", props.Disabled]]), wiring.RemoveProps))]]])) : defaultOf();
    const tryAgain = (errorFailure != null) ? ((errorFailure.tag === 2) ? HtmlHelper_createElement("button", append_1(ofArray([["type", "button"], ["className", actionButtonClass], ["children", singleton_1("Try again")], ["disabled", props.Disabled]]), wiring.TryAgainProps)) : defaultOf()) : defaultOf();
    return HtmlHelper_createElement("div", singleton_1(["children", toList(delay(() => append(singleton(HtmlHelper_createElement("label", ofArray([["className", props.LabelVisuallyHidden ? "sr-only" : TailwindHelpers_labelText], ["htmlFor", props.InputId], ["children", singleton_1(props.Label)]]))), delay(() => {
        let matchValue_5;
        return append((matchValue_5 = props.Hint, (matchValue_5 == null) ? singleton(defaultOf()) : singleton(HtmlHelper_createElement("p", ofArray([["id", hintId], ["className", TailwindHelpers_helperText], ["children", singleton_1(matchValue_5)]])))), delay(() => append(singleton(HtmlHelper_createElement("input", append_1(ofArray([["className", "peer sr-only"], ["id", props.InputId], ["type", "file"], ["accept", acceptAttribute], ["disabled", props.Disabled ? true : isUploading]]), append_1((describedBy === "") ? empty_1() : singleton_1(["aria-describedby", describedBy]), append_1((errorFailure != null) ? singleton_1(["aria-invalid", "true"]) : empty_1(), append_1(hasPhoto ? singleton_1(["tabIndex", -1]) : empty_1(), wiring.InputProps)))))), delay(() => append(singleton(body), delay(() => append(singleton(statusRegion(statusContent)), delay(() => {
            let matchValue_6;
            return append((matchValue_6 = errorFailure, (matchValue_6 == null) ? singleton(defaultOf()) : singleton(errorAlert(errorId, matchValue_6))), delay(() => append(singleton(tryAgain), delay(() => singleton(actions)))));
        }))))))));
    }))))]));
}

class PendingFocus extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NoFocus", "FocusInput", "FocusUploadOutcome"];
    }
}

function PendingFocus_$reflection() {
    return union_type("Shared.ImageUpload.PendingFocus", [], PendingFocus, () => [[], [], []]);
}

function postPhoto(file, authToken, measure, onCompleted, onFailed, onNetworkFailed) {
    const tokenStr = defaultArg(authToken, "");
    return             (async () => {
                try {
                    let width = 0, height = 0;
                    if (measure) {
                        try {
                            const bitmap = await createImageBitmap(file);
                            width = bitmap.width;
                            height = bitmap.height;
                            bitmap.close();
                        } catch (ex) { }
                    }
                    const formData = new FormData();
                    formData.append("file", file);
                    const headers = {};
                    if (tokenStr) { headers["Authorization"] = "Bearer " + tokenStr; }
                    const response = await fetch("/api/photos/upload", { method: "POST", body: formData, headers });
                    if (response.ok) {
                        const json = await response.json();
                        onCompleted(json.photoKey, json.photoUrl, json.thumbnailUrl, width, height);
                    } else {
                        onFailed(response.status);
                    }
                } catch (ex) {
                    onNetworkFailed();
                }
            })()
        ;
}

export function ImageUploadField($props) {
    const props = $props.props;
    const inputRef = useRef(undefined);
    const replaceRef = useRef(undefined);
    const tryAgainRef = useRef(undefined);
    const retainedFile = useRef(undefined);
    const pendingFocus = useRef(new PendingFocus(0, []));
    let stateKey;
    const matchValue = props.State;
    stateKey = ((matchValue.tag === 1) ? "uploading" : ((matchValue.tag === 2) ? "uploaded" : ((matchValue.tag === 3) ? "existing" : ((matchValue.tag === 4) ? "error" : "none"))));
    const dependencies = [stateKey];
    useEffect(() => {
        const setup = (() => {
        let disp;
        const matchValue_1 = pendingFocus.current;
        let matchResult;
        switch (stateKey) {
            case "none": {
                if (matchValue_1.tag === 1) {
                    matchResult = 0;
                }
                else {
                    matchResult = 3;
                }
                break;
            }
            case "uploaded": {
                if (matchValue_1.tag === 2) {
                    matchResult = 1;
                }
                else {
                    matchResult = 3;
                }
                break;
            }
            case "error": {
                if (matchValue_1.tag === 2) {
                    matchResult = 2;
                }
                else {
                    matchResult = 3;
                }
                break;
            }
            default:
                matchResult = 3;
        }
        switch (matchResult) {
            case 0: {
                iterate((input) => {
                    input.focus();
                }, toArray(inputRef.current));
                pendingFocus.current = (new PendingFocus(0, []));
                break;
            }
            case 1: {
                iterate((button) => {
                    button.focus();
                }, toArray(replaceRef.current));
                pendingFocus.current = (new PendingFocus(0, []));
                break;
            }
            case 2: {
                const matchValue_3 = props.State;
                let matchResult_1;
                if (matchValue_3.tag === 4) {
                    if (matchValue_3.fields[0].tag === 2) {
                        matchResult_1 = 0;
                    }
                    else {
                        matchResult_1 = 1;
                    }
                }
                else {
                    matchResult_1 = 1;
                }
                switch (matchResult_1) {
                    case 0: {
                        iterate((button_1) => {
                            button_1.focus();
                        }, toArray(tryAgainRef.current));
                        break;
                    }
                    case 1: {
                        iterate((input_1) => {
                            input_1.focus();
                        }, toArray(inputRef.current));
                        break;
                    }
                }
                pendingFocus.current = (new PendingFocus(0, []));
                break;
            }
        }
        disp = {
            Dispose() {
            },
        };
        return () => {
            let copyOfStruct = disp;
            disposeSafe(copyOfStruct);
        };
    })();
        return setup;
        }, dependencies);;
    const upload = (file) => {
        const matchValue_4 = PhotoFile_validateForUpload(toInt64_unchecked(fromFloat64(file.size)), file.type);
        if (matchValue_4.tag === 0) {
            pendingFocus.current = (new PendingFocus(2, []));
            props.OnUploadStarted();
            postPhoto(file, props.AuthToken, props.SmallImageThreshold != null, (key, url, thumb, width, height) => {
                props.OnUploaded(new UploadedPhoto(key, url, thumb, ((width > 0) && (height > 0)) ? (new ImageDimensions(~~width, ~~height)) : undefined));
            }, (status) => {
                props.OnFailed(UploadFailureModule_ofHttpStatus(status));
            }, () => {
                props.OnFailed(new UploadFailure(2, []));
            });
        }
        else {
            props.OnFailed(matchValue_4.fields[0]);
        }
    };
    return render(props, new Wiring(ofArray([["ref", (el) => {
        if (Operators_IsNull(el)) {
            inputRef.current = undefined;
        }
        else {
            inputRef.current = el;
        }
    }], ["onChange", (e) => {
        const input_2 = e.target;
        const matchValue_5 = input_2.files;
        if (equals(matchValue_5, defaultOf_1())) {
        }
        else if (matchValue_5.length === 0) {
        }
        else {
            const file_1 = matchValue_5[0];
            retainedFile.current = file_1;
            input_2.value = "";
            upload(file_1);
        }
    }]]), ofArray([["ref", (el_1) => {
        if (Operators_IsNull(el_1)) {
            replaceRef.current = undefined;
        }
        else {
            replaceRef.current = el_1;
        }
    }], ["onClick", (e_1) => {
        e_1.preventDefault();
        iterate((input_3) => {
            input_3.click();
        }, toArray(inputRef.current));
    }]]), singleton_1(["onClick", (e_2) => {
        e_2.preventDefault();
        pendingFocus.current = (new PendingFocus(1, []));
        props.OnRemove();
    }]), ofArray([["ref", (el_2) => {
        if (Operators_IsNull(el_2)) {
            tryAgainRef.current = undefined;
        }
        else {
            tryAgainRef.current = el_2;
        }
    }], ["onClick", (e_3) => {
        e_3.preventDefault();
        const matchValue_6 = retainedFile.current;
        if (matchValue_6 == null) {
            iterate((input_4) => {
                input_4.click();
            }, toArray(inputRef.current));
        }
        else {
            upload(matchValue_6);
        }
    }]])));
}

//# sourceMappingURL=ImageUpload.js.map
